import ListFieldFilter from '@pages/AdditionalServices/components/ServiceDirectory/ListTypeTemplate/ListFieldFilter';
import NumberFilterField from '@pages/AdditionalServices/components/ServiceDirectory/ListTypeTemplate/NumberFilterField';
import SwitchFieldFilter from '@pages/AdditionalServices/components/ServiceDirectory/ListTypeTemplate/SwitchFieldFilter';
import { PropertyFieldDisplayProps } from '@pages/AdditionalServices/components/ServiceDirectory/ListTypeTemplate/types';
import React, { FC } from 'react';

const PropertyFieldDisplay: FC<PropertyFieldDisplayProps<any>> = (props) => {
  const { data } = props;
  switch (data.Property.type) {
    case 'number':
      return <NumberFilterField {...props} />;
    case 'switch':
      return <SwitchFieldFilter {...props} />;
    case 'tax':
    case 'location':
    case 'handbook':
    case 'currency':
    case 'consulting_contractor':
    case 'inspection_contractor':
    case 'customs_contractor':
    case 'certification_contractor':
    case 'package':
    case 'product':
    case 'insurance_contractor':
      return <ListFieldFilter {...props} />;
  }

  return null;
};

export default PropertyFieldDisplay;
